// useThunkDispatch.ts
// Date Created: 06-25-2020

import { useDispatch } from 'react-redux';
import { store } from '../../configureStore';

export default () => useDispatch<typeof store.dispatch>();
